import FanPaymentRadioButtonComponent from "./FanPaymentRadioButtonComponent";

export default FanPaymentRadioButtonComponent;
